import * as React from 'react';
import { Capacitor } from '@capacitor/core';
import { useSearchParams, useParams } from 'react-router-dom';

export function useStatusBarScrollToTop<T extends HTMLElement>(ref: React.RefObject<T>) {
  const [searchParams] = useSearchParams();
  const params = useParams();

  React.useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const onStatusTap = () => {
      const el = ref.current;

      // If no ref element, do nothing
      if (!el) return;

      // SPOTS PAGE
      if (el.id === 'spots-page' && !!searchParams.get('s')) {
        // prevent when spot dialog is opened
        return;
      }

      // SEARCH PAGE
      if (el.id === 'search-page' && (params.slug || params.eventId)) {
        // prevent when spot dialog is opened
        return;
      }

      // Scroll the target element to top
      el.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    window.addEventListener('statusTap', onStatusTap);

    return () => {
      window.removeEventListener('statusTap', onStatusTap);
    };
  }, [ref, searchParams, params]);
}
